import { Layout } from "../../../layouts/v1";
import { MainView } from "../../../views/return-exchange/archive";
import { ReturnExchangeArchivesContextProvider } from "../../../views/return-exchange/archive/contexts/ReturnExchangeArchivesContext";

export function ReturnExchange_ArchivePage(props) {
    return (
        <>
            <ReturnExchangeArchivesContextProvider>
                <Layout>
                    <MainView />
                </Layout>
            </ReturnExchangeArchivesContextProvider>
        </>
    );
}